export class AttestationFooter {
    titrePoste?: {fr:string, en:string, nomDetenteur:string, qrCode:string};
    infoLine?:{
        boitePostal:string;
        tel: string[];
        fax: string[];
        email: string[];
    };
}